import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import api from "../Axios/api";
import Loader from "../common/Loader";

export default function SpareScreen() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState("");
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await api.get("/receipt-note/computer-parts-itSpare-list");

      // flatten items
      const flat = res.data.data.flatMap((grn) =>
        grn.items.map((item) => ({
          grn: grn.grn,
          entryDate: grn.entryDate,
          title: item.title || "-",
          qty: item.ITStockQty,
        }))
      );

      // sort latest first
      flat.sort((a, b) => new Date(b.entryDate) - new Date(a.entryDate));

      setData(flat);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const filteredData = data.filter((row) =>
  row.title.toLowerCase().includes(search.toLowerCase()) ||
  row.grn.toString().includes(search)
);

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      name: "GRN",
      selector: (row) => row.grn,
      sortable: true,
      width: "90px",center: true,
    },
    {
      name: "Date",
      selector: (row) =>
        new Date(row.entryDate).toLocaleDateString("en-IN"),
      sortable: true,
      width: "120px",center: true,
    },
    {
      name: "Item",
      selector: (row) => row.title,
      sortable: true,center: true,
      grow: 2,
    },
    {
      name: "Qty",
      selector: (row) => row.qty,
      sortable: true,
      center: true,
      width: "80px",center: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <span
          className={`px-2 py-1 rounded text-xs font-semibold ${
            row.qty > 0
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          {row.qty > 0 ? "In Stock" : "Out"}
        </span>
      ),
      center: true,
      width: "110px",
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        backgroundColor: "#e2e2e2",
        color: "#374151",
        borderRight: "1px solid #ddd",
        padding: "6px 8px",
      },
    },
  };

  return (
    <div className="min-h-screen p-6 bg-gray-100">
      <div className="max-w-8xl mx-auto bg-white rounded-xl shadow-lg p-6 border border-gray-300">
        <div className="flex flex-col md:flex-row justify-between items-center mb-4">
          <h1 className="text-2xl font-bold text-gray-800 mb-3 md:mb-0">
            IT Spare History
          </h1>
          <div className="flex justify-end mb-3">
  <input
    type="text"
    placeholder="Search item or GRN..."
    className="border rounded px-3 py-2 text-sm w-64"
    value={search}
    onChange={(e) => setSearch(e.target.value)}
  />
</div>
      </div>
      {isLoading ? (
        <Loader />
      ) : (
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          highlightOnHover
          persistTableHead
          customStyles={customStyles}
        />
       )}
      </div>
    </div>
  );
}